module.exports = __webpack_public_path__ + "img/hxclist.155f85c4.png";